module.exports = __webpack_public_path__ + "img/hzserive4.e1916f9b.jpg";